var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-operator" },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                  _c("span", { staticClass: "advert-tip" }, [
                    _vm._v(
                      "副屏广告按排序轮播：图片按时长切换、视频播放完或到时切下一条；无可用广告显示默认欢迎页"
                    ),
                  ]),
                ],
                1
              ),
              _c("a-table", {
                ref: "table",
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  pagination: false,
                  loading: _vm.loading,
                },
                scopedSlots: _vm._u([
                  {
                    key: "mediaSlot",
                    fn: function (text, record) {
                      return [
                        record.mediaType === "image"
                          ? _c("img", {
                              staticClass: "media-thumb",
                              attrs: { src: _vm.imgUrl(record.mediaUrl) },
                            })
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.imgUrl(record.mediaUrl),
                                  target: "_blank",
                                },
                              },
                              [
                                _c("a-icon", {
                                  attrs: { type: "video-camera" },
                                }),
                                _vm._v(" 视频预览"),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                  {
                    key: "typeSlot",
                    fn: function (text, record) {
                      return [
                        _c(
                          "a-tag",
                          {
                            attrs: {
                              color:
                                record.mediaType === "video"
                                  ? "purple"
                                  : "blue",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                record.mediaType === "video" ? "视频" : "图片"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "enabledSlot",
                    fn: function (text, record) {
                      return [
                        _c(
                          "a-tag",
                          {
                            attrs: {
                              color: record.enabled === "1" ? "blue" : "red",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(record.enabled === "1" ? "启用" : "停用")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(record)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(1) > -1 &&
                          _vm.btnEnableList.indexOf(4) > -1
                            ? _c("a-divider", { attrs: { type: "vertical" } })
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(4) > -1
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleToggle(record)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      record.enabled === "1" ? "停用" : "启用"
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(1) > -1 &&
                          _vm.btnEnableList.indexOf(4) > -1
                            ? _c("a-divider", { attrs: { type: "vertical" } })
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "确定删除该广告吗？" },
                                  on: {
                                    confirm: () => _vm.handleDelete(record.id),
                                  },
                                },
                                [_c("a", [_vm._v("删除")])]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
              _c("advert-modal", {
                ref: "modalForm",
                on: { ok: _vm.modalFormOk },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }